import { AppliedFilterChip, AppliedFilterChipVariant } from "@next-platform/client-common-spicy-ui";
import React, { useCallback } from "react";

import type { AppliedFilterChipData } from "./types";

type AppliedFilterChipCharacterProps = {
  chip: AppliedFilterChipData;
  onRemoveChip: (chip: AppliedFilterChipData) => void;
  getRemoveAriaLabel: (label: string) => string;
};

const AppliedFilterChipCharacter = ({ chip, onRemoveChip, getRemoveAriaLabel }: AppliedFilterChipCharacterProps) => {
  const handleRemoveChip = useCallback(() => onRemoveChip(chip), [chip, onRemoveChip]);

  return (
    <AppliedFilterChip
      data-testid={`AppliedFilterChipCharacter-${chip.sectionId}-${chip.value}`}
      label={chip.label}
      onRemove={handleRemoveChip}
      removeAriaLabel={getRemoveAriaLabel(chip.label)}
      variant={chip.isExcluded ? AppliedFilterChipVariant.EXCLUDE : AppliedFilterChipVariant.INCLUDE}
    />
  );
};

export default React.memo(AppliedFilterChipCharacter);
